import {
  Alert,
  Button,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormControlLabel,
  Container,
  TextField,
  Checkbox,
  Box,
  Typography,
  AlertTitle,
  RadioGroup,
  Radio,
  FormLabel

} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { checkAutoLogin } from 'src/actions/getTokenActions';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import moment from 'moment/moment';
import { PreloaderRow } from '../PreloaderRow';
import { useNavigate } from 'react-router';
import { PdfPreview } from 'src/pages/PdfPreview';

const MakeRechnung = React.memo((props) => {
  const [err, setError] = useState(false)
  const [errormessage, seterrormessage] = useState([]);
  const [AccountId, setAccountId] = useState(null)
  const [accountselect, setaccountselect] = useState([]);
  const [From, setFrom] = useState(moment.utc(new Date()).subtract(1, 'months').format());
  const [To, setTo] = useState(moment.utc(new Date()).format());
  const [IsAcceptInterpolate, setIsAcceptInterpolate] = useState(true)
  const [PriceRZE, setPricerze] = useState('')
  const [PriceRZH, setPricerzh] = useState('')
  const [url, setUrl] = useState('')
  const [fileName, setFileName] = useState('')
  const [Pue, setPue] = useState('')
  const [Tax, setTax] = useState('')
  const [IsWithDevices, setIsWithDevices] = useState(true)
  const [sortDevices, setSortDevices] = useState("Verbrauch")
  const [isDataCenterConsumeInclude, setisDataCenterConsumeInclude] = useState(true)
  const [isPueToShow, setPueToShow] = useState(false)
  const [showForm, setshowForm] = useState(true)
  const [preloader, setPreloader] = useState(false)
  const [isRequestFaled, setRequestFaled] = useState(false)

  const isLogin = useSelector(state => state.gettocken.islogin);
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const apiurl = sessionStorage.getItem('apiurl')

const set_sortDevices = (event) => {
  setSortDevices(event.target.value)
}
  const set_fromdate = (fromdate) => {
    if (fromdate !== "") {
      console.log("FROMDATE: ", fromdate)
      let startdateout = moment.utc(fromdate._d).format();
      
      setFrom(startdateout)
      console.log("FROM: ", startdateout)
    }
  }

  const set_todate = (endtime) => {
    if (endtime !== "") {
      let endtimedateout = moment.utc(endtime._d).format();
      setTo(endtimedateout)
      console.log("TO: ", endtimedateout)
    }
  }

  const set_AccountId = (e) => {
    setAccountId(e.target.value)
    if (e.target.value === "99") {
      setPueToShow(true)
    } else {
      setPueToShow(false)
    }
  }

  const set_Pricerze = (e) => {
    let val = e.target.value.replace(",", ".")
    setPricerze(val)
  }

  const set_Pricerzh = (e) => {
    let val = e.target.value.replace(",", ".")
    setPricerzh(val)
  }

  const set_Tax = (e) => {
    let val = e.target.value.replace(",", ".")
    setTax(val)
  }

  const set_Pue = (e) => {
    let val = e.target.value.replace(",", ".")
    setPue(val)
  }

  const set_IsAcceptInterpolate = () => {
    setIsAcceptInterpolate(!IsAcceptInterpolate)
  }

  const set_isDataCenterConsumeInclude = () => {
    setisDataCenterConsumeInclude(!isDataCenterConsumeInclude)
  }

  const set_IsWithDevices = () => {
    setIsWithDevices(!IsWithDevices)
  }

  const set_showForm = () => {
    setshowForm(!showForm)
  }

  const check_form = () => {
    let error = false
    seterrormessage([])

    let admission = moment(To, 'DD-MM-YYYY');
    let discharge = moment(From, 'DD-MM-YYYY');
    let test = discharge.diff(admission, 'days');

    console.log(From)
    console.log(To)


    if (AccountId === '') {
      let Accounterror = "Bitte wählen Sie einen Kunden aus"
      seterrormessage(errormessage => [...errormessage, Accounterror])
      setError(true)
      error = true
    }


    if (From === '') {
      let fromerror = "Startdatum muss angeben werden"
      seterrormessage(errormessage => [...errormessage, fromerror])
      setError(true)
      error = true
    }
    if (To === '') {
      let toerror = "Startdatum muss angeben werden"
      seterrormessage(errormessage => [...errormessage, toerror])
      setError(true)
      error = true
    }
    if (PriceRZE === '') {
      let priceerror = "Bitte geben Sie einen Strompreis für RZ-Estenfeld an!"
      seterrormessage(errormessage => [...errormessage, priceerror])
      setError(true)
      error = true
    }
    if (PriceRZH === '') {
      let priceerror = "Bitte geben Sie einen Strompreis für RZ-Heuchelhof an!"
      seterrormessage(errormessage => [...errormessage, priceerror])
      setError(true)
      error = true
    }

    if (Pue === '' && isPueToShow) {
      let pueerror = "Bitte geben Sie einen PUE Wert an!"
      seterrormessage(errormessage => [...errormessage, pueerror])
      setError(true)
      error = true
    }

    if (Tax === '') {
      let taxerror = "Bitte geben Sie einen Steuer Wert an!"
      seterrormessage(errormessage => [...errormessage, taxerror])
      setError(true)
      error = true
    }

    if (!error) {
      setPreloader(true)
      setshowForm(!showForm)
      sendbillingrequest()
    }
  }

  useEffect(() => {
    let token = checkAutoLogin(dispatch)
    if (!token && isLogin === false) {
      navigate('/login', { replace: true });
    } else {
      axios.get(`https://${apiurl}/api/Account`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
        }
      }).then(res => {
        let filterdata = res.data.filter(function (item) {
          return item.id !== 1;
        });
        setaccountselect(filterdata)
      }).catch(err => {
        console.log(err)
      })
    }
  }, [])



  const sendbillingrequest = () => {
    console.log(From + "|" + To + "|" + IsAcceptInterpolate + "|" + PriceRZE + "|" + Pue + "|" + IsWithDevices)
    console.log(errormessage.length)

    let accountfname
    if (AccountId === "99") {
      accountfname = "Gesamtrechnung"
    } else {
      accountfname = accountselect.find(a => a.id === AccountId).name
    }

    let fromfname = moment(From).format('YYYY/MM/DD')
    let tofname = moment(To).format('YYYY/MM/DD')
    let filename = accountfname + "-" + fromfname + "-" + tofname + ".pdf"

    let pricedata = '"dataCenterPrices":['
    pricedata += '{';
    pricedata += '"dataCenterName": "RZ-Estenfeld",';
    pricedata += '"price": "' + PriceRZE + '"';
    pricedata += '},{';
    pricedata += '"dataCenterName": "RZ-Heuchelhof",';
    pricedata += '"price": "' + PriceRZH + '"';
    pricedata += '}';
    pricedata += ']';

    let settingsfield = '{'
    settingsfield += '"accountId":"' + AccountId + '",';
    // settingsfield += '"belegNr": "' + BelegNr + '",';
    settingsfield += '"from":"' + From + '",';
    settingsfield += '"to":"' + To + '",';
    settingsfield += '"isDataCenterConsumeInclude":"' + isDataCenterConsumeInclude + '",';
    settingsfield += '"isAcceptInterpolate":"' + IsAcceptInterpolate + '",';
    settingsfield += '"pue":"' + Pue + '",';
    settingsfield += '"taxRate":"' + Tax + '",';
    settingsfield += '"isWithDevices":"' + IsWithDevices + '",';
    settingsfield += '"sortDeviceBy":"' + sortDevices + '",';
    settingsfield += pricedata
    settingsfield += '}';

    console.log(settingsfield)

    let token = checkAutoLogin(dispatch)
    if (!token && isLogin === false) {
      navigate('/login', { replace: true });
    } else {
      const headers = {
        'Content-Type': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      }
      axios.post("https://" + apiurl + "/api/Billing", settingsfield, {
        headers: headers,
        responseType: 'blob'
      })
        .then(res => {
        
       
        res.data.filename = fileName
         const blob = new Blob([res.data], {type: 'application/pdf', });
         blob.filename = accountfname + "-" + fromfname + "-" + tofname + ".pdf"
         console.log(blob) 
        
         let file = new File([res.data], accountfname + "-" + fromfname + "-" + tofname + ".pdf",  {type:"application/pdf"})
        
         console.log("FILE : ", file)
          const url1 = window.URL.createObjectURL(file);
         const url = window.URL.createObjectURL(blob); 

         
         console.log(url)
         console.log(url1)
         // const url = window.URL.createObjectURL(new Blob([res.data]));
         

          setUrl(url1)
          setFileName(filename)

          // const link = document.createElement('a');
          // link.href = url;
          // link.setAttribute('download', filename); //or any other extension
          // document.body.appendChild(link);
          // link.click();
          setError(false)
          setPreloader(false)
          setshowForm(!showForm)
          setPueToShow(false)

        })
        .catch(err => {
          setRequestFaled(true)
          setError(false)
          setPreloader(false)
          setPueToShow(false)
        })
    }
  }

  return (
    <Container maxWidth="sm">

      {showForm &&
        <Grid  >
          {err > 0 &&
            <Alert severity="error">
              <ul>
                {errormessage.map((message) => (
                  <li>{message}</li>
                ))}
              </ul>
            </Alert>
          }

          <Grid item xs={12} md={4}>
            <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
              <InputLabel id="demo-simple-select-label">Kunde</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Age"
                value={AccountId}
                onChange={set_AccountId}
              >
                {accountselect ? accountselect.map(accountitem => {
                  return <MenuItem value={accountitem.id}>{accountitem.name}</MenuItem>
                }) : null
                }
                <MenuItem value="99">Gesamtrechnung</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
              <TextField value={PriceRZE} id="outlined-basic" label="RZ-Estenfeld: Strompreis (EUR/kWh)" variant="outlined" 
              onChange={(e) => set_Pricerze(e)} />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
              <TextField value={PriceRZH} id="outlined-basic" label="RZ-Heuchelhof: Strompreis (EUR/kWh)" variant="outlined"
               onChange={(e) => set_Pricerzh(e)} />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
              <TextField value={Tax} id="outlined-basic" label="Steuer, %" variant="outlined" onChange={(e) => set_Tax(e)} />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4} padding={1}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                label="Datum von"
                value={From}
                inputFormat="DD.MM.YYYY"
                onChange={(From) => {
                  set_fromdate(From);
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={4} padding={1}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                label="Datum bis"
                value={To}
                minDate={From}
                inputFormat="DD.MM.YYYY"
                onChange={(To) => {
                  set_todate(To);
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
              <TextField value={Pue} id="outlined-basic" label="PUE Wert" variant="outlined" onChange={(e) => set_Pue(e)} />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
              <FormControlLabel value={IsAcceptInterpolate} control={<Checkbox onClick={(e) => set_IsAcceptInterpolate(e)}  checked={IsAcceptInterpolate}/>} 
              label="Interpolierte Werte" />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
              <FormControlLabel value={isDataCenterConsumeInclude} control={<Checkbox onClick={(e) => set_isDataCenterConsumeInclude(e)}  checked={isDataCenterConsumeInclude}/>} 
              label="Verbrauchsorientierte Aufteilung der RZ Süd Werte auf andere Kunden" />
            </FormControl>
          </Grid>


          <Grid item xs={12} md={6}>
            <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
              <FormControlLabel value={IsWithDevices}  control={<Checkbox onClick={(e) => set_IsWithDevices(e)} checked={IsWithDevices}/>} label="Deviceliste auf Rechnung anzeigen" />
            </FormControl>
          </Grid>

{
  IsWithDevices &&
  <Grid item xs={12} md={6}>
            <FormControl sx={{ m: 1, minWidth: 300, alignItems: 'flex-end' }} size="small">
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                // defaultValue="Verbrauch"
                name="radio-buttons-group"
                value={sortDevices}
                onChange={set_sortDevices}
              >
                <FormControlLabel value="Verbrauch" control={<Radio />} label="absteigend nach Verbrauch" />
                <FormControlLabel value="Rack" control={<Radio />} label="nach Rack" />
              </RadioGroup>
            </FormControl>
          </Grid>
}
          <Grid item xs={12} md={4} padding={1}>
            <FormControl sx={{ m: 1, minWidth: 250 }} size="small">
              <Button variant="contained" color="success" onClick={() => check_form()} >Rechung erzeugen</Button>
            </FormControl>
          </Grid>
        </Grid>
      }

      {!showForm && !preloader && !isRequestFaled &&
        <Grid>
          <PdfPreview name={fileName} currentAttachedUrl={url} closeFile={() => set_showForm()} currentAttachedType={'pdf'} />
        </Grid>
      }

      {preloader && <Grid>
        <Alert severity="info">
          <AlertTitle>Bitte warten Sie</AlertTitle>
          Der Bericht wird erstellt!</Alert>
        <PreloaderRow />
      </Grid>}

      {isRequestFaled && <Grid>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          Es ist ein Fehler aufgetreten! Bitte versuchen Sie es noch mal.
        </Alert>
        <FormControl sx={{ m: 1, minWidth: 250 }} size="small">
              <Button variant="contained" color="success" onClick={() =>{ set_showForm(); setRequestFaled(false)}} >zurück zum Eingabeformular</Button>
            </FormControl>
      </Grid>
      }
    </Container>

  );
});

export default MakeRechnung;
